import Certificate from './certificate';

const templates = [
  {
    id: 'ADHOC_CERT',
    label: 'Document',
    template: Certificate,
  },
];

export default templates;
